import { useEffect, useState } from 'react';

const hasDarkMode = () => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

export const useDarkMode = () => {
    const [isDarkMode, setDarkMode] = useState<boolean>(hasDarkMode());

    useEffect(() => {
        const listener = () => { setDarkMode(hasDarkMode()); };
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', listener);
        return () => {
            window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', listener);
        };
    }, []);

    return isDarkMode;
};
